import React from 'react'
import './col-indicator.css'

function ColIndicator() {
  return (
    <div className='main-col-indicator'>
      <div className='main-col-indicator-mask'></div>
      <div className='main-col-indicator-left'></div>
      <div className='main-col-indicator-right'></div>
    </div>
  )
}

export default ColIndicator